








































import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {},
  directives: {}
})
export default class ValidationMessagesDialog extends BaseComponent {
  @Prop()
  messages: any;

  formOpen = false;

  public $refs!: {
    form: HTMLFormElement;
  };

  public form: any = {
    valid: false
  };

  mounted() {
    this.formOpen = true;

    setTimeout(() => {
      this.$refs['tf_0'].focus();
    }, 300);
  }

  public salvar(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }
    this.$emit('save');
  }

  closeForm() {
    this.$emit('cancel');
  }

  getRules(item) {
    const palavra = item.palavraChaveCiente;
    let f = (v) => (!!v && v.toLowerCase() == palavra.toLowerCase()) || 'Digite a palavra: ' + palavra;
    return [f];
  }
}
